import { Button } from "components";
import React from "react";
import { createPortal } from "react-dom";
import styles from "./booking-flow-screening-switch-modal.module.css";

type BookingFlowScreeningSwitchModalProps = {
    title: string;
    bodyHtml: string;
    confirmLabel: string;
    cancelLabel: string;
    confirmLoading?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

const BookingFlowScreeningSwitchModal: React.FunctionComponent<BookingFlowScreeningSwitchModalProps> = ({
    title,
    bodyHtml,
    confirmLabel,
    cancelLabel,
    confirmLoading = false,
    onConfirm,
    onCancel,
}) => {
    const modal = (
        <div className={styles.scrim} role="presentation">
            <div
                className={styles.dialog}
                role="dialog"
                aria-modal="true"
                aria-labelledby="booking-flow-screening-switch-title"
            >
                <h2
                    id="booking-flow-screening-switch-title"
                    className={styles.title}
                >
                    {title}
                </h2>
                <p
                    className={styles.body}
                    dangerouslySetInnerHTML={{ __html: bodyHtml }}
                />
                <div className={styles.actions}>
                    <Button loading={confirmLoading} onClick={onConfirm}>
                        {confirmLabel}
                    </Button>
                    <Button type="secondary" onClick={onCancel}>
                        {cancelLabel}
                    </Button>
                </div>
            </div>
        </div>
    );

    if (typeof document === "undefined") {
        return modal;
    }

    return createPortal(modal, document.body);
};

export default BookingFlowScreeningSwitchModal;
